module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.visatype) ? _c('div', {
    staticClass: "panel-nav",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.sections), function(section, key) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.secKey === key
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.secKey = key
        }
      }
    }, [_vm._v(_vm._s(section.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "matterHolder"
  }, [(_vm.visatype && _vm.matter && _vm.section) ? _c('div', _vm._l((_vm.section.subsections), function(sub) {
    return _c('div', [(_vm.showSub(sub)) ? _c('div', _vm._l((_vm.subcounts[sub.ref]), function(n) {
      return _c('div', {
        staticClass: "panel",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "panel-header"
      }, [_c('div', {
        staticClass: "panel-title"
      }, [_c('h3', [_vm._v(_vm._s(sub.name) + " "), (n > 1) ? _c('span', [_vm._v("(" + _vm._s(n) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, _vm._l((sub.questions), function(q) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showQ(q)),
            expression: "showQ(q)"
          }],
          key: q.ref
        }, [(q.type === 'text') ? _c('textQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'yn') ? _c('boolQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'select') ? _c('selectQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'date') ? _c('dateQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'number') ? _c('numberQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'textarea') ? _c('textareaQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'country') ? _c('countryQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'language') ? _c('languageQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : _vm._e()], 1)
      }), 0), _vm._v(" "), (sub.repeatable && n === _vm.subcounts[sub.ref]) ? _c('button', {
        staticClass: "btn btn-sm btn-primary float-right",
        staticStyle: {
          "width": "155px"
        },
        on: {
          "click": function($event) {
            return _vm.addSub(sub)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-plus"
      }), _vm._v("Add another\n            ")]) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c1ff5ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/clientMatter.vue
// module id = 497
// module chunks = 1